import { Form } from "antd";
import { useEffect } from "react";
import { FormModal } from "@/shared/components/FormModal";
import { useCreateTask } from "../hooks/useTasks";
import { useTasksStore } from "../store/tasks.store";
import type { CreateTaskRequest } from "../types";
import { TaskForm, type TaskFormValues } from "./TaskForm";

export function buildCreateTaskRequest(values: TaskFormValues): CreateTaskRequest {
	return {
		title: values.title,
		description: values.description,
		typeId: values.typeId,
		priority: values.priority ?? "MEDIUM",
		organizationId: values.organizationId,
		brigadeId: values.brigadeId,
		dueDate: values.dueDate ? values.dueDate.toISOString() : undefined,
		status: values.status ?? "PENDING",
		targetType: values.targetType,
		locations:
			values.targetType === "LOCATION"
				? (values.locations ?? [])
						.filter((entry) => entry.geometry)
						.map((entry) => ({ type: entry.type, geometry: entry.geometry }) as never)
				: undefined,
		plantingIds: values.targetType === "PLANT" ? values.plantingIds : undefined,
	};
}

export function TaskFormModal() {
	const [form] = Form.useForm<TaskFormValues>();
	const { createModalOpen, closeCreateModal } = useTasksStore();

	const { mutate: create, isPending: isCreating } = useCreateTask();

	useEffect(() => {
		if (createModalOpen) {
			form.resetFields();
		}
	}, [createModalOpen, form]);

	const handleClose = () => {
		closeCreateModal();
		form.resetFields();
	};

	const handleSubmit = () => {
		form
			.validateFields()
			.then((values) => {
				create(buildCreateTaskRequest(values), { onSuccess: handleClose });
			})
			.catch(() => {
				// Validation failed - Form shows errors inline
			});
	};

	return (
		<FormModal
			title="Yangi topshiriq"
			open={createModalOpen}
			onCancel={handleClose}
			onOk={handleSubmit}
			confirmLoading={isCreating}
			width={720}
		>
			<TaskForm form={form} />
		</FormModal>
	);
}
